export interface FilterOption {
  label: string;
  value: string;
  count?: number;
}

export interface FilterSection {
  title: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
}

interface FilterSidebarProps {
  sections: FilterSection[];
}

export default function FilterSidebar({ sections }: FilterSidebarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      {sections.map((section, idx) => (
        <div key={section.title} className={idx > 0 ? "mt-4 border-t border-background-200 pt-4" : ""}>
          <h3 className="mb-2 flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
            <span>{section.title}</span>
          </h3>
          <ul className="flex flex-wrap gap-1.5 lg:flex-col lg:gap-1">
            {section.options.map((opt) => {
              const active = section.value === opt.value;
              return (
                <li key={opt.value}>
                  <button
                    type="button"
                    onClick={() => section.onChange(opt.value)}
                    className={`flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm whitespace-nowrap transition-colors ${
                      active
                        ? "bg-primary-100 font-medium text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`}
                  >
                    <span>{opt.label}</span>
                    {opt.count != null && (
                      <span className="ml-2 text-xs text-foreground-400">{opt.count}</span>
                    )}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}